<template>
  <div :class="classes">
    <asd20-spinner :color="color" :size="size" />
    <div class="asd20-loader__label" v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>

<script>
import Asd20Spinner from '../../atoms/Asd20Spinner'

export default {
  name: 'Asd20Loader',
  components: { Asd20Spinner },
  props: {
    color: { type: String, default: '' },
    size: {
      type: String,
      default: 'xs',
      validator: value => {
        // The value must match one of these strings
        return ['xs', 'sm', 'md', 'lg'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    classes() {
      let c = {
        'asd20-loader': true,
      }
      c[`asd20-loader--${this.size}`] = true
      return c
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';

.asd20-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(white, 0.9);
  color: var(--color__secondary-t30);
  font-weight: bold;
  font-size: 0.875rem;
  &__label {
    margin-top: space(1);
  }
}
</style>
